/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_CallInputs */

const et_pricing_call = /** @type {(inputs: Pricing_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helista`)
};

const en_pricing_call = /** @type {(inputs: Pricing_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call`)
};

/**
* | output |
* | --- |
* | "Call" |
*
* @param {Pricing_CallInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const pricing_call = /** @type {((inputs?: Pricing_CallInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_CallInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_pricing_call(inputs)
	return en_pricing_call(inputs)
});